export interface User {
  id: string;
  providerId: number;
  email: string;
  roles: string[];
  firstName: string;
  lastName: string;
  startingDate: Date;
  isActive: boolean;
  isOnBench?: boolean;
  erpLastModified: Date;
  userJob: UserJob;
  department: Department;
  avatarUrl: string;
  contractPeriods: UserContractPeriod[];
}

export interface UserJob {
  id: string;
  name: string;
}

export interface Department {
  id: string;
  name: string;
}

interface UserContractPeriod {
  startDate: Date;
  endDate: Date;
}

export type UserStatusFilter = "active" | "bench" | "all";

export const DEFAULT_USER_STATUS: UserStatusFilter = "active";

export interface UsersPage {
  content: User[];
  totalPages: number;
  totalElements: number;
}
